const { REDIRECT_PREARRIVAL_URL } = process.env;
export const URL_CONSTANTS = {
  HTTPS_STRING: 'https://',
  ITEM_PATH_ROOT: 'root/responsivegrid',
  ITEM_PATH_EXP_F: 'root',
  ITEM_PATH_HEADER: 'root/header-responsivegrid',
  ITEM_PATH_FOOTER: 'root/footer-responsivegrid',
};
export const ALPHABETS_REGEX = /^[a-zA-Z]+$/;
export const EMAIL_REGEX =
  /^(([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))*$/;
export const PHONE_NUM = /^\+?\d+$/;
export const childrenAge = [
  { label: '<1', value: '<1' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
];
export const transportationType = [
  { label: 'Private Plane', value: 'Private Plane' },
  { label: 'Commercial Airline', value: 'Commercial Airplane' },
  { label: 'Car', value: 'Car' },
  { label: 'Train', value: 'Train' },
  { label: 'Other', value: 'Other' },
];

export const relationshipTypeDefaultOption = { value: '', label: 'Relationship Type', id: 'relationship-type' };
export const relationshipTypes = [
  { value: 'Spouse / Domestic Partner', label: 'Spouse / Domestic Partner', id: 'spouse-domestic-partner' },
  { value: 'Parent', label: 'Parent', id: 'parent' },
  { value: 'Sibling', label: 'Sibling', id: 'sibling' },
  { value: 'Other Extended Family Member', label: 'Other Extended Family Member', id: 'other-extended-member' },
  { value: 'Friend', label: 'Friend', id: 'friend' },
  { value: 'Other', label: 'Other', id: 'other' },
];
export const countriesDialTimeZoneDefaultOption = { label: 'Select' };
export const countriesDialTimeZone = [
  { value: 'EST', label: 'EST' },
  { value: 'CST', label: 'CST' },
  { value: 'MST', label: 'MST' },
  { value: 'GMT', label: 'GMT' },
  { value: 'UTC', label: 'UTC' },
  { value: 'ECT', label: 'ECT' },
  { value: 'EET', label: 'EET' },
  { value: 'ART', label: 'ART' },
  { value: 'EAT', label: 'EAT' },
  { value: 'MET', label: 'MET' },
  { value: 'NET', label: 'NET' },
  { value: 'PLT', label: 'PLT' },
  { value: 'IST', label: 'IST' },
  { value: 'BST', label: 'BST' },
  { value: 'VST', label: 'VST' },
  { value: 'CTT', label: 'CTT' },
  { value: 'JST', label: 'JST' },
  { value: 'ACT', label: 'ACT' },
  { value: 'SST', label: 'SST' },
  { value: 'NST', label: 'NST' },
  { value: 'MIT', label: 'MIT' },
  { value: 'HST', label: 'HST' },
  { value: 'AST', label: 'AST' },
  { value: 'PST', label: 'PST' },
  { value: 'PNT', label: 'PNT' },
  { value: 'IET', label: 'IET' },
  { value: 'PRT', label: 'PRT' },
  { value: 'CNT', label: 'CNT' },
  { value: 'AGT', label: 'AGT' },
  { value: 'BET', label: 'BET' },
  { value: 'CAT', label: 'CAT' },
  // Add more options as needed
];
export const ENTER_KEY = 'Enter';
export const TAB_KEY = 'Tab';
export const BACKSPACE_KEY = 'Backspace';
export const mailConst = {
  OUTLET_ADDITIONAL_SECTION: 'Outlet Additional Section',
  OUTLET_EMAIL_CONTACT: 'R&B Email Link',
  EXTERNAL_LINK: 'external',
};
export const brandColorSchemeGenerator = (value?: string, component?: string): string => {
  if (value === null || value === '' || value === undefined) {
    return 'color-scheme';
  } else {
    switch (value) {
      case 'NBF':
        // Non Brand Flag
        if (component === undefined) {
          return 'color-scheme1';
        }
        if (component === 'header') {
          return 'color-scheme1';
        } else if (component === 'footer') {
          return 'color-scheme1';
        } else {
          return 'color-scheme1';
        }
      case 'RZ':
        // ritz
        if (component === undefined) {
          return 'color-scheme4';
        }
        if (component === 'header') {
          return 'color-scheme';
        } else if (component === 'footer') {
          return 'color-scheme5';
        } else if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'RZR':
        // ritz reserve
        if (component === undefined) {
          return 'color-scheme4';
        }
        if (component === 'header') {
          return 'color-scheme';
        } else if (component === 'footer') {
          return 'color-scheme5';
        } else if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'WH':
        // W hotel
        if (component === undefined) {
          return 'color-scheme3';
        }
        if (component === 'header') {
          return 'color-scheme2';
        } else if (component === 'footer') {
          return 'color-scheme2';
        } else if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme3';
        }
      case 'JW':
        if (component === undefined) {
          return 'color-scheme4';
        }
        if (component === 'header') {
          return 'color-scheme4';
        } else if (component === 'footer') {
          return 'color-scheme4';
        } else if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'MD':
        // Le Meridian
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'TX':
        // Tribute
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'SI':
        // Sheraton
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme5';
        }
      case 'MC':
        // Marriott
        return 'color-scheme5';
      case 'FS':
        // Marriott also but wrong initial code
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme5';
        }
      case 'BR':
        // Renaissance
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme1';
        }
      case 'WI':
        // Westin
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'AK':
        // Autograph Collection
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'GE':
        // Gaylord
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      case 'DE':
        // Delta
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme6';
        }
      case 'DS':
        // Design
        return 'color-scheme5';
      case 'BA':
        // appartments by Marriott
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme4';
        }
      default:
        if (component === 'carousel') {
          return 'color-scheme1';
        } else {
          return 'color-scheme';
        }
    }
  }
};

export const partySizeValueDefaultOption = { value: '', label: 'Select', id: 'partySizeSelect' };
export const partySizeValue = [
  { value: '1', label: '1', id: 'partySize1' },
  { value: '2', label: '2', id: 'partySize2' },
  { value: '3', label: '3', id: 'partySize3' },
  { value: '4', label: '4', id: 'partySize4' },
  { value: '5', label: '5', id: 'partySize5' },
  { value: '6', label: '6', id: 'partySize6' },
  { value: '7', label: '7', id: 'partySize7' },
  { value: '8', label: '8', id: 'partySize8' },
  { value: '9', label: '9', id: 'partySize9' },
  { value: '10+', label: '10+', id: 'partySize10Pluss' },
];

// Sample dining checkbox data
export const diningCheckboxData = [
  { name: 'fineValue', label: 'Fine', enabled: '' },
  { name: 'casualValue', label: 'Casual', enabled: '' },
  { name: 'localCuisines', label: 'Local Cuisine', enabled: '' },
  { name: 'goodForKids', label: 'Good for Kids', enabled: '' },
  { name: 'privateExperience', label: 'Private Experience', enabled: '' },
  { name: 'veganValue', label: 'Vegan', enabled: '' },
  { name: 'italianValue', label: 'Italian', enabled: '' },
  { name: 'americanValue', label: 'American', enabled: '' },
  { name: 'asianValue', label: 'Asian', enabled: '' },
  { name: 'continentalValue', label: 'Continental', enabled: '' },
  { name: 'mexicanValue', label: 'Mexican', enabled: '' },
  { name: 'vegeterianValue', label: 'Vegetarian', enabled: '' },
];

//sample Dietry Checkbox data
export const dietryCheckboxData = [
  { name: 'noAlcoholValue', label: 'No Alcohol', enabled: '' },
  { name: 'noEggsValue', label: 'No Eggs', enabled: '' },
  { name: 'noPeanutsValue', label: 'No Peanuts', enabled: '' },
  { name: 'noWheatValue', label: 'No Wheat', enabled: '' },
  { name: 'lowFatValue', label: 'Low Fat', enabled: '' },
  { name: 'dietryVeganValue', label: 'Vegan', enabled: '' },
  { name: 'noBeefValue', label: 'No Beef', enabled: '' },
  { name: 'noFishValue', label: 'No Fish', enabled: '' },
  { name: 'noPorkValue', label: 'No Pork', enabled: '' },
  { name: 'glutenFreeValue', label: 'Gluten Free', enabled: '' },
  { name: 'lowSodiumValue', label: 'Low Sodium', enabled: '' },
  { name: 'dietryVegetarianValue', label: 'Vegetarian', enabled: '' },
  { name: 'noDairyValue', label: 'No Dairy', enabled: '' },
  { name: 'noNutsValue', label: 'No Nuts', enabled: '' },
  { name: 'noSoyValue', label: 'No Soy', enabled: '' },
  { name: 'kosherHalalValue', label: 'Kosher/Halal', enabled: '' },
  { name: 'lowSugarValue', label: 'Low Sugar', enabled: '' },
  { name: 'noShellfish', label: 'No Shellfish', enabled: '' },
];

//Activities Check box data
export const activitiesCheckboxData = [
  { name: 'exploreTheLocalAreaCulture', label: 'Explore the local area & culture', enabled: '' },
  { name: 'golfActivites', label: 'Golf activities', enabled: '' },
  { name: 'connectToTheLocalEnvironment', label: 'Connect to the local environment', enabled: '' },
  { name: 'wellnessRelatedActivities', label: 'Wellness-related activities', enabled: '' },
  { name: 'familyFriendlyActivites', label: 'Family-friendly activities', enabled: '' },
  { name: 'guidedTours', label: 'Guided tours', enabled: '' },
  { name: 'waterActivites', label: 'Water activities', enabled: '' },
  { name: 'shoppingValue', label: 'Shopping', enabled: '' },
  { name: 'spaActivities', label: 'Spa activities', enabled: '' },
];

export const HYBRID_CONFIG_CONSTANTS = {
  ROUTING_CONFIG: 'routingConfig',
  EXPERIENCE_SEGMENT: ['NOT Logged In'],
  EXPERIENCE_SEGMENT_AUTHENTICATED: ['Logged In'],
  MOCK_SESSION_ID: '7FC3A108-DF69-5E10-B767-6D2FB461B924',
};

export const DCA_CONSTANTS = {
  gcv: 'AMCV_664516D751E565010A490D4C@AdobeOrg',
  MCMID_COOKIE: 'MCMID',
};
export const MOCK_SESSION_ID = '7FC3A108-DF69-5E10-B767-6D2FB461B924';
export const PPV5_URL_FORMAT = 'einterface/v5';
export const REDIRECT_URL_SURVEY = REDIRECT_PREARRIVAL_URL;
export const DATALAYER_CONSTANT = {
  headerKeys: [
    'accept-language',
    'user-agent',
    'x-request-id',
    'x-service-id',
    'x-forwarded-host',
    'x-host',
    'x-xm-site-id',
    'x-lite-site',
    'x-request-uri',
    'x-request-host',
    'sec-fetch-user',
    'x-forwarded-for',
    'x-schema',
    'sec-fetch-mode',
    'x-forwarded-port',
    'sec-fetch-site',
    'sec-fetch-dest',
    'x-forwarded-proto',
    'referer',
    'forwarded',
    'messageid',
    'x-akamai-edgescape',
    'x-akamai-device-characteristics',
    'x-client-ip',
    'x-akamai-config-log-detail',
    'akamai-origin-hop',
    'digitalserviceswitch',
  ],
};

//Guest Details Accessibility checkbox
export const accessiblityDetailsCheckboxData = [
  { name: 'mobilityAccessible', label: 'Mobility Accessible', enabled: '' },
  { name: 'mobilityAccessibleWithRollInShower', label: 'Mobility Accessible with Roll-In Shower', enabled: '' },
  { name: 'mobilityAccessibleWithTub', label: 'Mobility Accessible with Tub', enabled: '' },
  { name: 'hearingAccessible', label: 'Hearing Accessible', enabled: '' },
];

////Guest Details contact checkbox
export const preferredContactCheckboxData = [
  { name: 'tripEmailCheckbox', label: 'Email', field: 'tripEmail', type: 'email' },
  { name: 'tripPhoneCheckbox', label: 'Phone Call', field: 'tripPhoneNumber', type: 'phone' },
  { name: 'tripTextCheckbox', label: 'Text', field: 'tripTextNumber', type: 'text' },
  { name: 'tripWechatCheckbox', label: 'WeChat', field: 'tripWeChatNumber', type: 'wechat' },
  { name: 'tripWhatsappCheckbox', label: 'WhatsApp', field: 'tripWhatsAppNumber', type: 'whatsapp' },
];

////Guest Details special Ocasion checkbox
export const specialOcationCheckboxData = [
  { name: 'soBirthdayCheckbox', label: 'Birthday' },
  { name: 'soCelebrationCheckbox', label: 'Celebration' },
  { name: 'soAnniversaryCheckbox', label: 'Anniversary' },
  { name: 'soOtherCheckbox', label: 'Other' },
];

////Guest Details contact checkbox
export const specialCheckboxData = [
  { name: 'soEmailCheckbox', label: 'Email', field: 'tripEmail', type: 'email' },
  { name: 'soPhoneCallCheckbox', label: 'Phone Call', field: 'tripPhoneNumber', type: 'phone' },
  { name: 'soTextCheckbox', label: 'Text', field: 'tripTextNumber', type: 'text' },
  { name: 'soTripCheckbox', label: 'WeChat', field: 'tripWeChatNumber', type: 'wechat' },
  { name: 'soWhatsAppCheckbox', label: 'WhatsApp', field: 'tripWhatsAppNumber', type: 'whatsapp' },
];

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const capitalize = (str: any) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const LONG_MONTH_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const SHORT_MONTH_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const SHORT_WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const LONG_WEEK_DAYS_NAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const CALENDAR_MAX_ALLOWED_DAYS = 3 * 365;
export const categoryNameMappings: { fullname: string; shortname: string }[] = [
  { fullname: 'immersive spa treatments', shortname: 'spa' },
  { fullname: 'fitness', shortname: 'FIT' },
  { fullname: 'seafood', shortname: 'SF' },
  { fullname: 'mexican', shortname: 'MX' },
  { fullname: 'french', shortname: 'FR' },
  { fullname: 'Local Cuisine', shortname: 'LC' },
  { fullname: 'Grill', shortname: 'GR' },
  { fullname: 'Continental', shortname: 'CN' },
  { fullname: 'Asian-Fusion', shortname: 'AF' },
  { fullname: 'Japanese', shortname: 'JP' },
  { fullname: 'Steakhouse', shortname: 'SH' },
];

export const ENCRYPT_KEY_ENDPOINT = '/mi/phoenix-account-auth/v1/encryptionKey/credential';

export const EMAIL_DATA_KEY = 'customer_email';
export const CONSENT_FORM_KOREA_COOKIE_NAME = 'MarketingConsent';
export const CONSENT_FORM_EMEA_COOKIE_NAME = 'EmeaMarketingConsent';
export const MASKED_PHONE = 'masked_phone';
export const ENCRYPTED_VERIFY_DATA = 'encrypted_verify_data';
export const EAA_FCP_WARNING_MESSAGE_KEY = 'eaaFcpWarningMessage';
export const CHECKED_IN_MODAL_ID = 'checked-in';
export const REDEMPTION_DTT_MODAL = 'dtt-points-rate';
export const PLATINUM_CORE_CODE = 'P';
export const SIGN_IN_PAGE_WARN_MESSAGE = 'signInPageWarnMessage';
export const TRACKING_PAGE_NAME = 'tracking_page_name';
export const MFA_OPTIONS_KEY = 'mfa_option';
export const SHOW_BROWSER_REGISTRATION = 'show_browser_registration';
export const ENCRYPTED_DATA = 'encrypted_data';
export const PASSWORD_ERROR_MSG = 'password.username.invalid';
export const REMEMBER_ME_KEY = 'remember_me';
export const LAST_ATTEMPT_WARNING_KEY = 'incorrect.password.last.attempt.remaining';
export const LOCKEDOUT_ERROR_KEY = 'account.lockedout.dueto.password.failure.attempts';
export const ALREADY_COMBINED_ERROR_KEY = 'transferred.marriott.rewards.account.status';
export const AUDIT_WARNING_MESSAGE = 'audit.marriott.rewards.account.status';
export const USERNAME_INVALID_ERROR = 'username.type.invalid';
export const LOGIN_URL = '/mi/phoenix-account-auth/v1/loginWithCredentials';
// export const LOGIN_URL = 'https://www.marriott.com/mi/phoenix-account-auth/v1/loginWithCredentials';
export const LOGIN_LINK_RESERVATION_URL = '/mi/phoenix-account-auth/v1/loginWithCredentialsAndLink';
export const LOGIN_LINK_RESERVATION_DTT_URL = '/mi/phoenix-account-auth/v2/loginWithCredentialsAndLink';

export const SignInconstants = {
  RTL_LANG_LIST: `:lang(he-IL), :lang(ar-AE)`,
  NOTO_SANS_LANG_LIST: `:lang(ko-KR), :lang(ja-JP), :lang(zh-CN), :lang(zh-TW) `,
  ARABIC_LANG: `:lang(ar-AE)`,
  HEBREW_LANG: `:lang(he-IL)`,
  JAPAN_COUNTRY_CODE: 'JP',
  KOREA_COUNTRY_CODE: 'KR',
  CANADA_COUNTRY_CODE: 'CA',
  ARABIC_COUNTRY_CODE: 'AE',
  CHINA_COUNTRY_CODE: 'CN',
  USA_COUNTRY_CODE: 'US',
  MEXICO_COUNTRY_CODE: 'MX',
  ARGENTINA_COUNTRY_CODE: 'AR',
  TRADITIONAL_CHINA_COUNTRY_CODE: 'TW',
  CHINA_HK_LOCALE_CODE: 'HK',
  CHINA_MO_LOCALE_CODE: 'MO',
  DEFAULT_LANG: 'en',
  BRITISH_LANG: 'gb',
  DEFAULT_COUNTRY: 'US',
  THAI_LANG: 'th',
  ITEM_PATH_ROOT: 'root/responsivegrid',
  BORDER10: 'rgba(0,0,0,0.1)',
  ACTIVE_NAV: 'rgba(28, 28, 28, 0.3)',
  TRANSPARENT: 'transparent',
  STANDARD_DATE_FORMAT: 'YYYY-MM-DD',
  TAB_UPCOMING: 'tabUpcoming',
  TAB_CANCELLED: 'tabCancelled',
  TAB_BUSINESS: 'tabBusiness',
  TAB_LEISURE: 'tabLeisure',
  CONTACT_OPT_PH: 'PH',
  CONTACT_OPT_BOTH: 'BOTH',
  MAX_BRAND_TAGS: 3,
  BOLD_FONT_WEIGHT: 800,
  SESSION_TIME_OUT_URL: '/sessionTimeOut',
  RES_LOOKUP_ID: 'reservationlookup',
  UNAUTH_URL: '/unAuth',
  ENROLL_PREFILL: '/enrollprefill',
  PROMOTION_PREPROCESSOR_URL: '/promotion',
  NO_DECIMAL_LOCALE: ['ko_KR'],
  KOREAN_CURRENCY: 'KRW',
  //Activity Codes
  STAY: 'STAY',
  RWD_EVENT: 'RWD EVENT',
  BONUS: 'BONUS',
  OTHER: 'OTHER',
  SUITE_NIGHT: 'suite-night',
  MILES_CURRENCY_CODE: 'MI',
  POINTS_CURRENCY_CODE: 'HP',
  //Activity Codes END
  MR_ENROLLED: 'mr_enrolled',
  LOYALTY_PAGE_PATH: '/loyalty',
  FIND_RESERVATION_LIST_PAGE_URL: '/loyalty/findReservationList.mi',
  CREATE_ACCOUNT_PAGE_URL: '/loyalty/createAccount/createAccountPage1.mi',
  STATUS_SUCCESS: 'SUCCESS',
  INVALID_PARTNER_NUMBER: 'INVALID_PARTNER_NUMBER',
  UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
  DC_ERROR_FLAG: 'profile.registered.to.dc.program',
  STATUS_FAILURE: 'FAILURE',
  HOME_PHONE_CODE: 'HT',
  BUSINESS_PHONE_CODE: 'BT',
  MOBILE_PHOHE_CODE: 'MT',
  USA_COUNTRY_DIAL_CODE: '+1',
  RESERVATION_LINKED: 'reservationLinkedMsg',
  USA_COUNTRY: 'USA',
  ALLOWED_YEAR_THRESHOLD: 100,
  CONVERSION_POINTS_SYMBOL: '=',
  RAKUTEN_PARTNER: 'RK',
  MGM_PARTNER: 'MM',
  PARTNER_CURRENCY: 'POINTS',
  MILES: 'MILES',
  NEXT_PUBLIC_ENV_KEYS: [
    'PROHIBITED_COUNTRIES_CODES',
    'CREDIT_CARD_EXPIRY_YEAR_LIMIT',
    'SWEEPSTAKES_RESTRICTED_PROVINCES',
    'SWEEPSTAKES_OTP_PAGE_URL',
    'SWEEPSTAKES_FINAL_API_URL',
    'COBRAND_LOCALE',
    'HOMEPAGE_REDIRECT_URL',
    'IS_PASSWORD_ENCRYPT',
    'SKIP_DECODE_URL_FOR_PATH',
    'FETCH_MEMBER_DETAILS_FOR_PATHS',
    'PROMOS_WITHOUT_DEFAULT_EARNED_TEXT',
    'NEXT_PUBLIC_GRAPHQL_URL',
    'NEXT_PUBLIC_PREFIX',
    'NEXT_PUBLIC_DEFAULT_LANG',
    'ADD_CARD_MARSHA_CODE',
    'CHECK_IN_ELIGIBLE_DOMAINS',
    'NEXT_PUBLIC_SUBMIT_SEARCH_URL',
    'LOCALIZED_NAME_LOCALES',
    'HIDE_MOB_NUM_FOR_COUNTRIES',
    'PATTERN_THREE_COUNTRIES',
    'HIDE_PAID_MEDIA_MARKETING_CONSENT_FOR_COUNTRIES',
    'URLS_TO_CLEAR_SESSION_DATA',
    'OTA_CREATOR_IDS',
    'NEXT_PUBLIC_DAC_LOGO_ENABLE',
  ],
  CHECK_IN_CONFIRMATION: '/reservation/check-in-confirmation.mi',
  FIND_RESERVATION_DETAIL: '/reservation/upcomingReservation.mi',
  LOGOUT_URL: 'logout',
  SYSTEM_MAINTENANCE: 'systemMaintenance',
  GERMAN_LOCALE: 'de-de',
  US_LOCALE: 'en-us',
  DEFAULT: 'DEFAULT',
  FONTICON: 'fonticon',
  TEXT: 'text',
  HIDE_ROW_HEADER: 'HIDE-ROW-HEADER',
  ICON: 'ICON',
  CONTENTBLOCKV2: 'CONTENT_BLOCK_V2',
  LOCALE_KEY_CHINA: 'zh-CN',
  OTP_LOCKOUT_ERROR_MESSAGE: 'otpLockedOutErrorMessage',
  EAA_ERROR_URL: '/error',
  EAA_LOGIN_URL: '/login',
  MCOM_LOGIN_URL: '/sign-in.mi',
  SONDER_BRAND_CODE: 'SN',
  EMAIL: 'email',
  PHONE: 'phone',
  OTP_EMAIL: 'OTP_EMAIL',
  OTP_PHONE: 'OOB_SMS',
  MEMBER_LEVEL_CODE: ['R', 'MRD', 'MGD'],
  VERTICAL_PIPE: '|',
  TITANIUM_LEVEL_CODE: 'PPC',
  VARIATION_2: 'V2',
  CORE_LEVEL_CODE: ['R', 'S', 'G'],
  SILVER_MEMBER_NIGHTS: 10,
};

export const TRACKING_CONSTANTS = {
  SIGNIN: 'Sign In',
  REMEMBER_ME: 'Remember Me',
  JOIN_NOW: 'Join Now',
  FORGOT_PASSWORD: 'Forgot Password',
  ACTIVATE_ONLINE_ACCOUNT: 'Activate Online Account',
  CLEAR_REMEMBER_ME: 'Clear Remember Me',
  EYE_TOGGLE: 'Eye Toggle',
  INTERNAL: 'internal',
  JOIN_FOR_FREE: 'Join for Free',
  JOIN_AND_CONTINUE: 'Join and Continue',
  EMAIL_PHONE: 'Email or Phone Radio Buttons',
  SEND_CODE: 'Send Code',
  VERIFY_CODE: 'Verify',
  RESEND_CODE: 'Resend a New Code',
  CANCEL: 'Cancel',
  ENTER_YOUR_CODE: 'Enter Your Code',
  PROMOTION_ENROLLMENT: 'Promotion Enrollment',
  SWEEPSTAKES: 'Sweepstakes',
  SWEEPSTAKES_SIGNIN: 'Sweepstakes Sign In',
};
/* eslint-disable @typescript-eslint/no-explicit-any */
export const getPassionData = (datas: any) => {
  if (Object.keys(datas).length != 0) {
    const newArr = Object.entries(datas).map(([key, value]) => {
      if (value === null || value === '') return [key, '0'];
      if (typeof value === 'string' && (value.toLowerCase() === 'casual' || value.toLowerCase() === 'enthusiast')) {
        value = '1';
      }
      return [key, value];
    });

    return Object.fromEntries(newArr);
  }
};

export const DINING_SUBCATEGORY_OPTIONS = [
  { key: 'local_cuisine', value: 'Local Cuisine' },
  { key: 'grill', value: 'Grill' },
  { key: 'continental', value: 'Continental' },
  { key: 'mexican', value: 'Mexican' },
  { key: 'asian-fusion', value: 'Asian-Fusion' },
  { key: 'japanese', value: 'Japanese' },
  { key: 'steakhouse', value: 'Steakhouse' },
  { key: 'international', value: 'International' },
  { key: 'mediterranean', value: 'Mediterranean' },
  { key: 'italian', value: 'Italian' },
  { key: 'american', value: 'American' },
  { key: 'pizza', value: 'Pizza' },
  { key: 'french', value: 'French' },
  { key: 'seafood', value: 'Seafood' },
  { key: 'southern', value: 'Southern' },
  { key: 'english', value: 'English' },
  { key: 'eclectic', value: 'Eclectic' },
  { key: 'coffee_house', value: 'Coffee House' },
  { key: 'casual', value: 'Casual' },
  { key: 'vegan', value: 'Vegan' },
  { key: 'vegetarian', value: 'Vegetarian' },
  { key: 'good_for_kids', value: 'Good for Kids' },
  { key: 'private_experience', value: 'Private Experience' },
  { key: 'other', value: 'Other' },
];

export const EXPERIENCE_SUBCATEGORY_OPTIONS = [
  { key: 'fitness', value: 'Fitness' },
  { key: 'golf', value: 'Golf' },
  { key: 'spa', value: 'Spa' },
  { key: 'swimming', value: 'Swimming' },
  { key: 'children_activities', value: 'Children Activities' },
  { key: 'recreation', value: 'Recreation' },
  { key: 'shopping', value: 'Shopping' },
  { key: 'tours', value: 'Tours' },
  { key: 'seasonal', value: 'Seasonal' },
  { key: 'none', value: 'None' },
];

export const getSubcategoryLabel = (subcategory: string): string => {
  const allOptions = [...DINING_SUBCATEGORY_OPTIONS, ...EXPERIENCE_SUBCATEGORY_OPTIONS];
  const match = allOptions.find(option => option.key === subcategory);
  return match ? match.value : subcategory;
};

//check if the brand is luxury
export const isValidLuxuryBrand = (brandName: string): boolean => {
  const validBrands = ['RZ', 'RZR', 'WH', 'JW', 'XR', 'EB', 'LC'];

  return validBrands.includes(brandName.toUpperCase());
};
export const ALLOWED_TAGS_IN_DESCRIPTION = [
  'b',
  'strong',
  'i',
  'em',
  'u',
  's',
  'del',
  'sub',
  'sup',
  'mark',
  'small',
  'big',
  'ul',
  'ol',
  'li',
  'dl',
  'dt',
  'dd',
  'table',
  'tr',
  'td',
  'th',
  'thead',
  'tbody',
  'tfoot',
  'colgroup',
  'col',
  'caption',
  'p',
  'br',
  'hr',
  'blockquote',
  'pre',
  'a',
  'code',
  'span',
  'div',
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
];
